import { Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { TeamsRoutes } from 'pages/settings/pages/teams/route/type'
import { TeamsProvider } from 'pages/settings/pages/teams/context/teamsContext'
import { TeamsPage } from 'pages/settings/pages/teams/ui/TeamsPage'
import { TeamsCreateLayout } from 'pages/settings/pages/teams/ui/TeamsCreate'
import { ManageTeamMembersLayout } from 'pages/settings/pages/teams/ui/ManageTeamMembers'

export const TeamsRouter = observer(() => {
  return (
    <TeamsProvider>
      <Routes>
        <Route index element={<TeamsPage />} />
        <Route path={TeamsRoutes.create} element={<TeamsCreateLayout />} />
        <Route path={TeamsRoutes.manage} element={<ManageTeamMembersLayout />} />
      </Routes>
    </TeamsProvider>
  )
})
